export const CONFIG_LOCALHOST = 'localhost';
export const CONFIG_DEV = 'dev';
export const CONFIG_DEV1 = 'dev1';
export const CONFIG_DEV2 = 'dev2';
export const CONFIG_DEMO = 'demo';
export const CONFIG_DEMO_1 = 'demo1';
export const CONFIG_UAT = 'uat';
export const CONFIG_UATPOLICY = 'uatpolicy';
export const CONFIG_STG = 'stg';
export const CONFIG_QA = 'qa';
export const CONFIG_QA1 = 'qa1';
export const CONFIG_QA2 = 'qa2';
export const CONFIG_SB = 'sb';
export const CONFIG_SIT = 'sit';
export const CONFIG_PROD = 'prod';
export const CONFIG_KLEARDEMO = 'kleardemo';
export const CONFIG_ECO = 'eco';
export const CONFIG_PRE_PROD = 'preprod';
export const PRODCOBB = "cobbk12";
export const PRODWSDOT = 'wsdot';
export const PTEST = 'ptest';

export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const EXPIRES_IN = 'EXPIRES_IN';
export const TOKEN_TIME = 'TOKEN_TIME';
export const SUB_DOMAIN = 'SUB_DOMAIN';
export const DEFAULT_SUB_DOMAIN = '';
export const KLEARAI_BG_IMAGE = 'KLEARAI_BG_IMAGE';
export const KLEARAI_BG_LOGO = 'KLEARAI_BG_LOGO';
export const CLIENT_LOGO = 'CLIENT_LOGO';
export const DISCLAIMER = 'DISCLAIMER';
export const ENVIRONMENT = 'env';
export const ENVIRONMENTS = ['localhost', 'dev', 'qa', 'uatpolicy', 'uat', 'stg', 'demo', 'sb', 'sit', 'preprod'];
export const LOCALHOST = 'localhost';
export const DEVELOPMENT = 'dev';
export const QA = 'qa';
export const DEMO = 'DEMO';
export const UAT = 'uat';
export const UATPOLICY = 'uatpolicy';
export const STAGING = 'stg';
export const PRODUCTION = 'prod'
export const PRE_PROD = 'preprod'
export const SANDBOX = 'sb'
export const SIT = 'sit'
export const PRODUCT_ID = 'PRODUCT_ID';

export const NOTE = "note";
export const TASK = "task";
export const MEMO = "memo";

export const TOPBAR_LOGO_URL = 'assets/img/demo.png';
export const LOGIN_LOGO_URL = 'assets/img/demo.png';
export const KLEARAI_LOGO_URL = 'assets/img/KlearAI.png';

export const APP_BLOB_CONFIGURATION = {
    blobSassUrl: 'https://klearaiconfig.blob.core.windows.net/',
    container: 'config/',
    logoDirectory: 'logos/',
    configDirectory: 'configs/',
    token: '?sp=racwdlme&st=2025-12-30T14:31:19Z&se=2027-12-31T17:00:19Z&spr=https&sv=2024-11-04&sr=c&sig=zwKVych2xMy7bRUAJW4Mylft6XjUEyZiw2rxAsqXbbo%3D',
    configFile: 'url-config.json'
}